/**
 * Хранилище состояния умного поиска с ИИ.
 * Живёт в памяти SPA (модуль-синглтон) и переживает переход на /job/:id и обратно,
 * в отличие от useState внутри компонента, который сбрасывается при размонтировании.
 */
const store = {
  query: "",
  res: null, // ответ API ai_search.php (used + jobs + total)
  savedScrollY: 0, // позиция скролла, где пользователь оставил результаты
};

export const getAiSearchState = () => store;
export const setAiSearchState = (query, res) => {
  store.query = query;
  store.res = res;
};
export const clearAiSearchState = () => {
  store.query = "";
  store.res = null;
  store.savedScrollY = 0;
};
export const setAiSearchScroll = (y) => {
  store.savedScrollY = y;
};